/* @flow */
import * as React from 'react';

import Glyph from 'components/Glyph.jsx';

type GlyphMap = { [string]: React.Element<Glyph> };

export function getGlyphCellGenerator(fieldName: string, glyphMap: GlyphMap) {
  return (data: Object) => {
    const glyph = glyphMap[data[fieldName]];
    return glyph ? React.cloneElement(glyph) : <span data-test="empty-glyph-cell" />;
  };
}
